import DeepL from "./../Resource_Icons/Deepl.svg"
import Google from "./../Resource_Icons/g-translate.svg"


import Seznam from "./../Resource_Icons/seznam_cz.svg"
import Centrum from './../Resource_Icons/centrum.svg'
import Forvo from './../Resource_Icons/forvo.svg'

import CzechSbS from './../Resource_Icons/CzSbS.svg'

import ce1 from './../Resource_Icons/ce1_logo.png'
import ce2 from './../Resource_Icons/ce2_logo.png'
import ce3 from './../Resource_Icons/ce3_logo.png'

export const resource_data = [
    {
        id: 1,
        name: 'DeepL Translator',
        image: DeepL,
        url: 'https://www.deepl.com/translator',
    },
    {
        id: 2,
        name: 'Google Translate',
        image: Google,
        url: 'https://translate.google.com/?hl=en&tab=TT',
    },
    {
        id: 3,
        name: 'Slovnik.cz',
        image: '',
        url: 'https://www.slovnik.cz/',
    },
    {
        id: 4,
        name: 'Seznam.cz Slovnik',
        image: Seznam,
        url: 'https://slovnik.seznam.cz/',
    },
    {
        id: 5,
        name: 'Centrum.cz Slovniky',
        image: Centrum,
        url: 'http://slovniky.centrum.cz/',
    },
    {
        id: 6,
        name: 'Forvo',
        image: Forvo,
        url: 'https://forvo.com/languages/cs/',
    },
    {
        id: 7,
        name: 'Number Listening Practice',
        image: '',
        url: 'https://langpractice.com/czech/',
    },
    {
        id: 8,
        name: 'Czech Step By Step',
        image: CzechSbS,
        url: 'https://www.czechstepbystep.cz/materialy-on-line',
    },
    {
        id: 9,
        name: 'ONLINE PRACTICE / EXERCISES',
        image: '',
        url: 'https://www.czechstepbystep.cz/en/cestina-expres-1-online-practise',
    },
    {
        id: 10,
        name: 'SHORT CZECH NEWS',
        image: '',
        url: 'https://www.czechstepbystep.cz/en/kategorie/short-czech-news',
    },
    {
        id: 11,
        name: 'flashcards 1',
        image: ce1,
        url: 'http://www.czechonlinetutor.com/cz/cesky-online/cestina-expres-1',
    },
    {
        id: 12,
        name: 'flashcards 2',
        image: ce2,
        url: 'http://www.czechonlinetutor.com/cz/cesky-online/cestina-expres-2',
    },
    {
        id: 13,
        name: 'flashcards 3',
        image: ce3,
        url: 'http://www.czechonlinetutor.com/cz/cesky-online/cestina-expres-3',
    },
]